import Command from './Command';
import common from '../common';

export default class MorphCommand extends Command {
	constructor() {
		super('ui_function_omnitrix_bg_9slice');

		this.type = Command.TYPE_TRANSFORM;
		this.variable = null;

		this.options = [];
		this.variableLabel = null;
		this.variableIcon = null;

		this.variableActive = true;
		this.defaultVariable = 'ben';

		this.signals.onVariableTouch = new P3.utils.MiniSignal();

		this.init();

		this.variableBackground.visible = false;
		this.variableLabel.visible = false;
	}

	init() {
		this.ui.off('pointerdown');
		this.ui.off('pointerup');
		this.ui.off('pointerupoutside');
		this.ui.off('pointermove');

		this.ui.destroy();
		this.ui = null;

		this.ui = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_function_omnitrix_bg_9slice'), 32, 33, 0, 33);

		this.ui.width = common.commandDimensions.width;
		this.ui.height = common.commandDimensions.height;
		this.ui.position.x = -(this.ui.width >> 1);
		this.ui.position.y = -(this.ui.height >> 1);

		this._tempheight = Math.floor(60 * common.commandScale);
		this.ui.interactive = true;

		this.addChild(this.ui);

		super.init('GAME.BLOCKS.TRANSFORM', 'ui_icon_omnitrix');

		this.player.signals.transform.add(() => {
			P3.utils.delay(0.5, () => {
				this.signals.executionComplete.dispatch();
			});
		}, this);

		for (const item in this.player.animationData) {
			if (!common.levelSettings.allowedAliens.includes(item)) {
				continue;
			}

			this.options.push(this.player.animationData[item].printname);
		}

		this.on('pointertap', (e) => {
			e.stopPropagation();

			if (e.target.parent !== this.parent) {
				if (!this.canChangeVariable) {
					return;
				}
				e.target.parent.signals.onVariableTouch.dispatch(e.target.parent, e);

				return;
			}

			this.signals.onVariableTouch.dispatch(this, e);
		});

		this.variableIcon = new PIXI.Sprite(PIXI.Texture.EMPTY);
		const iconScale = (common.commandDimensions.height - (4 * common.commandSpacing)) / this.variableIcon.texture.height;
		this.variableIcon.scale.set(iconScale);
		this.variableIcon.position.x = this.commandLabel.x + this.commandLabel.width + common.commandSpacing + (this.variableIcon.width >> 1);
		this.variableIcon.position.y = -(common.commandTopBottomOffset >> 1) - 1;
		this.addChild(this.variableIcon);

		this.initEvents();
	}

	setText(text) {
		const tex = `ui_function_char_${text.toLowerCase()}`;

		this.variableIcon.texture = P3.assets.texture(tex);
		const iconScale = ((common.commandDimensions.height - (4 * common.commandSpacing)) / this.variableIcon.texture.height) - 0.1;
		this.variableIcon.anchor.set(0.5);
		this.variableIcon.scale.set(iconScale);
		this.variableIcon.position.x = this.commandLabel.x + this.commandLabel.width + common.commandSpacing + (this.variableIcon.width >> 1);
		this.variableIcon.position.y = -(common.commandTopBottomOffset >> 1) - 1;

		this.addChild(this.variableIcon);

		if (this.ui.width < this.width) {
			this.ui.width = this.width + common.commandSpacing;
		}
	}

	onPointerMove(event) {
		super.onPointerMove(event);

		/* if (this.y - this.height * 0.5 < 0) {
			this.y = this.height * 0.5;
		} else if (this.y + this.height * 0.5 > common.STAGE_HEIGHT) {
			this.y = common.STAGE_HEIGHT - this.height * 0.5;
		} */
	}

	execute() {
		this.player.transform(this.variable);
	}
}
